import React from "react"
import MultiSelectFilter from "./Filter Types/multiSelect"
import NumInputFilter from "./Filter Types/numInput"

const FilterType = ({filterType, filterName, filterParams}) => {

    if (filterType === 'multiSelect') {

        return(
            <MultiSelectFilter
                filterName={filterName}
                filterParams={filterParams}
            />
        )
    } else if (filterType === 'numInput') {
       
        return (
            <NumInputFilter
                filterName={filterName}
                filterParams={filterParams}
            />
        )
    } else {
        return (
            <div></div>
        )
    }

}

export default FilterType